// extracted by mini-css-extract-plugin
module.exports = {"loading":"loadingSpinner__loading2Y0","spin":"loadingSpinner__spin1yY"};